module.exports = __webpack_public_path__ + "img/checkbox-area-selected.370ac3b0.svg";